module.exports = __webpack_public_path__ + "static/img/report_logo.aab6c294.png";